import LootManager from './LootManager';

function App() {
  return (
    <div className="App">
      <LootManager />
    </div>
  );
}

export default App;
